import { useTranslation } from "react-i18next";

export function CategorySelect({ value, onChange }) {
  const { t } = useTranslation();
  const cats = [
    "ELECTRONIQUE","DOCUMENTS_IDENTITE","BAGAGES","BIJOUX_MONTRES",
    "VETEMENTS","CLES","PORTEFEUILLE_SAC","AUTRE"
  ];
  return (
    <select value={value} onChange={onChange}
      style={{ width:"100%", padding:"12px 16px", border:"1.5px solid #E2E8F0",
        borderRadius:"12px", fontSize:"14px", outline:"none", boxSizing:"border-box" }}>
      <option value="">—</option>
      {cats.map(c => <option key={c} value={c}>{t("categories." + c)}</option>)}
    </select>
  );
}

export function ColorSelect({ value, onChange }) {
  const { t } = useTranslation();
  const colors = [
    "noir","blanc","bleu","rouge","vert","jaune","marron","gris","orange","argent"
  ];
  return (
    <select value={value} onChange={onChange}
      style={{ width:"100%", padding:"12px 16px", border:"1.5px solid #E2E8F0",
        borderRadius:"12px", fontSize:"14px", outline:"none", boxSizing:"border-box" }}>
      <option value="">—</option>
      {colors.map(c => <option key={c} value={c}>{t("colors." + c)}</option>)}
    </select>
  );
}

export function TransactionTypeSelect({ value, onChange }) {
  const { t } = useTranslation();
  const types = [
    "REMISE_ARGENT","DEPOT_BIEN","TRANSMISSION_RESPONSABILITE",
    "ACCORD_VERBAL","RECONNAISSANCE_DETTE","AUTRE"
  ];
  return (
    <select value={value} onChange={onChange}
      style={{ width:"100%", padding:"12px 16px", border:"1.5px solid #E2E8F0",
        borderRadius:"12px", fontSize:"14px", outline:"none", boxSizing:"border-box" }}>
      <option value="">—</option>
      {types.map(tt => <option key={tt} value={tt}>{t("transaction_types." + tt)}</option>)}
    </select>
  );
}
